module.exports = __webpack_public_path__ + "img/0Q3A9771_L.b293d0ad.webp";